import React from 'react';
import { usePermissions } from '@/hooks/usePermissions';
import { AccessDenied } from '@/pages/AccessDenied';
import type { Permission } from '@/types/permissions';

interface ProtectedRouteProps {
  permission: Permission | Permission[];
  requireAll?: boolean;
  component?: React.ComponentType;
  children?: React.ReactNode;
}

export function ProtectedRoute({
  permission,
  requireAll = false,
  component: Component,
  children
}: ProtectedRouteProps) {
  const { hasPermission, hasAllPermissions, hasAnyPermission } = usePermissions();

  // Handle single permission
  if (typeof permission === 'string') {
    if (!hasPermission(permission)) {
      return <AccessDenied />;
    }
    return Component ? <Component /> : <>{children}</>;
  }

  // Handle multiple permissions
  const hasAccess = requireAll
    ? hasAllPermissions(...permission)
    : hasAnyPermission(...permission);

  if (!hasAccess) {
    return <AccessDenied />;
  }

  return Component ? <Component /> : <>{children}</>;
}
